var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13118 10.1174C3.87616 9.88553 4.01469 9.46638 4.35962 9.42617L9.24714 8.85645C9.38772 8.84007 9.50982 8.75298 9.56912 8.6266L11.6306 4.23259C11.7761 3.9225 12.2245 3.92246 12.37 4.23255L14.4315 8.62666C14.4908 8.75305 14.6121 8.84007 14.7527 8.85646L19.6404 9.42617C19.9854 9.46638 20.1238 9.88556 19.8688 10.1174L16.2556 13.4028C16.1516 13.4973 16.1052 13.6381 16.1328 13.7747L17.0918 18.5208C17.1595 18.8557 16.7969 19.1148 16.4939 18.948L12.1992 16.5845C12.0756 16.5165 11.9252 16.5164 11.8016 16.5844L7.50654 18.948C7.20345 19.1148 6.84049 18.8558 6.90819 18.5208L7.86742 13.7746C7.89501 13.6381 7.84867 13.4973 7.74473 13.4028L4.13118 10.1174Z",
    fill: "#B152F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarFill);
export default __webpack_public_path__ + "static/media/icon-star-fill.7c077dc9d37381172121afa117e50ead.svg";
export { ForwardRef as ReactComponent };